import { useRef, useEffect } from 'react';
import { Button, Text, Flex } from '@smarterservices/smarter-ui';
import CONSTANTS from '../../config/constants';
import Name from './Name';
//import AvatarStack from './AvatarStack';
//import Settings from './Settings';
import ReviewStatus from './ReviewStatus';
import HeaderBar from '@ui/shared/components/Common/HeaderBar';
import Help from './Help';
import DiagnosticsButton from './DiagnosticsButton';
import { getStore } from '../../stores/StoreContext';
import NameInfo from './NameInfo';

const Header = () => {
    const headerRef = useRef(null);
    const LayoutStore = getStore('layoutStore');

    useEffect(() => {
        if (headerRef.current) {
            LayoutStore.setHeaderRef(headerRef.current);
        }
    }, [headerRef]);
    return (
        <HeaderBar
            elementRef={(el) => {
                headerRef.current = el;
            }}
            margin="xx-small small none small"
            padding="none none none xx-small"
            background="primary"
            height={CONSTANTS.HEADER_BAR.HEIGHT}
            leftContent={
                <Flex direction="row" alignItems="center" gap="xx-small">
                    <Flex.Item>
                        <Name />
                    </Flex.Item>
                    <Flex.Item>
                        <NameInfo />
                    </Flex.Item>
                </Flex>
            }
            rightContent={
                <Flex direction="row" alignItems="center" gap="x-small">
                    <Flex.Item>
                        <ReviewStatus />
                    </Flex.Item>
                    <Flex.Item>
                        <DiagnosticsButton />
                    </Flex.Item>
                    <Flex.Item>
                        <Help />
                    </Flex.Item>
                </Flex>
            }
        />
    );
};

export default Header;
